import useArchive from "@hooks/useArchive"
import SalonParticipation from "../components/Participation"

export default function useGalleryArchive(participations?: Admin.Resources.Participation[]) {
    const archive = useArchive(participations)

    archive.useComponent(SalonParticipation)
    archive.useOptions({ idx: true })
    archive.useGrid({ columns: "4" })
    archive.usePagination(100, "photos")
    archive.useEmpty({
        heading: "No photos in this category.",
        description: `Sorry, we can't find photos.`
    })

    return archive
}